import React from 'react';
import { useTranslation } from '@/contexts/LanguageContext';
import { SlideNumberPosition } from '@/types';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface ConfigPanelProps {
  showSlideNumbers: boolean;
  setShowSlideNumbers: (show: boolean) => void;
  showVerifiedBadge: boolean;
  setShowVerifiedBadge: (show: boolean) => void;
  slideNumberPosition: SlideNumberPosition;
  setSlideNumberPosition: (position: SlideNumberPosition) => void;
  slideNumberPositionOptions: Array<{ value: SlideNumberPosition; label: string }>;
}

const ConfigPanel: React.FC<ConfigPanelProps> = ({
  showSlideNumbers,
  setShowSlideNumbers,
  showVerifiedBadge,
  setShowVerifiedBadge,
  slideNumberPosition,
  setSlideNumberPosition,
  slideNumberPositionOptions,
}) => {
  const { t } = useTranslation();

  return (
    <div className="p-3 space-y-4">
      <div className="flex items-center justify-between">
        <Label className="text-sm font-medium">{t('workspace.slideNumbers')}</Label>
        <Switch checked={showSlideNumbers} onCheckedChange={setShowSlideNumbers} />
      </div>
      {showSlideNumbers && (
        <div className="flex items-center justify-between">
          <Label className="text-sm font-medium">{t('workspace.slideNumberPosition') || 'Posição'}</Label>
          <Select value={slideNumberPosition} onValueChange={(value) => setSlideNumberPosition(value as SlideNumberPosition)}>
            <SelectTrigger className="w-[140px] h-8"><SelectValue /></SelectTrigger>
            <SelectContent>
              {slideNumberPositionOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>{option.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
      <div className="flex items-center justify-between">
        <Label className="text-sm font-medium">{t('workspace.verifiedBadge')}</Label>
        <Switch checked={showVerifiedBadge} onCheckedChange={setShowVerifiedBadge} />
      </div>
    </div>
  );
};

export default ConfigPanel;
